import { analytics } from './analyticsSetup'
import { notifyToast } from './analyticsToastBridge'
import { UserEventDataMap, UserEventKey, userEventNames } from './userEvents'

export { analytics } from './analyticsSetup'

export async function anonymizedUser(userId: string): Promise<string> {
    const encoder = new TextEncoder()
    const data = encoder.encode(userId)
    const hashBuffer = await crypto.subtle.digest('SHA-256', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

export function trackUserEvent<K extends UserEventKey>(key: K, data?: UserEventDataMap[K]) {
    const eventName = userEventNames[key]

    const properties = data && 'numberOfEdits' in data ? { ...data, selection: data.numberOfEdits <= 1 ? 'single' : 'multiple' } : (data ?? {})

    // if analytics is enabled; on local this is undefined
    if (analytics) {
        analytics
            .track(eventName, properties)
            .then(() => {
                notifyToast(`[User Event]: ${eventName}`, 'success')
            })
            .catch(_ => {
                notifyToast(`[User Event]: ${eventName}`, 'error')
            })
    } else {
        notifyToast(`[User Event]: ${eventName}`, 'success')
    }
}
